import {bleskAuthStore, parseJwtUser} from '@blesk-frontend/auth';
import {useEffect} from 'react';

/**
 *
 */
export const useUmamiIdentify = () => {
  const {token} = bleskAuthStore();

  useEffect(() => {
    if (import.meta.env.DEV) {
      return;
    }

    if (token) {
      const user = parseJwtUser(token);

      if (!user) {
        return;
      }

      window.umami?.identify(user.id, {
        email: user.email,
        fullName: user.fullName || '',
        teamId: user.teamId || '',
      });
    }
  }, [token]);
};
